import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleBarReact from 'simplebar-react';
import { Link } from 'react-router-dom';
import { faFileInvoice, faCircle } from '@fortawesome/free-solid-svg-icons';
import { yellow } from '@mui/material/colors';
import SubtleBadge from 'components/common/SubtleBadge';

const Previsao = ({
  previsao: {
    id,
    processo,
    registro,
    modalidade,
    desembaraco,
    operacao,
    referencia,
    canal
  },
  isLast
}) => {
  let sigla =
    operacao === 'Agenciamento' ? 'A' : operacao === 'Exportação' ? 'E' : 'I';
  let corCircle = canal;
  return (
    <Row className="g-3 pb-s1">
      <Col>
        <Row
          className={classNames('g-3', { 'mb-3 border-bottom pb-s1': !isLast })}
        >
          <Col xs={2} sm={1} className="d-flex justify-content-center">
            <FontAwesomeIcon
              icon={classNames({
                plane:
                  modalidade === 'AÉREO' ||
                  modalidade === 'AIRFREIGHT' ||
                  modalidade === 'Aéreo',
                truck:
                  modalidade === 'RODOVIÁRIO' ||
                  modalidade === 'Rodoviário' ||
                  modalidade === 'RODOVIARIO',
                ship:
                  modalidade === 'Marítimo' ||
                  modalidade === 'Maritimo' ||
                  modalidade === 'MARITIMA' ||
                  modalidade === 'MARÍTIMO (LCL)' ||
                  modalidade === 'MARÍTIMO (FCL)'
              })}
              size="lg"
            />
          </Col>
          <Col xs={4} sm={2}>
            <h6
              className="text-800 mb-1 text-center"
              style={{ fontSize: '12px' }}
            >
              {processo}
            </h6>
          </Col>
          <Col xs={4} sm={2}>
            <h6
              className="text-800 mb-1 text-center"
              style={{ fontSize: '0.625em' }}
            >
              {referencia}
            </h6>
          </Col>
          <Col xs={4} sm={2}>
            <h6
              className="text-600 mb-1 text-center"
              style={{ fontSize: '0.625em' }}
            >
              {registro}
            </h6>
          </Col>
          <Col xs={4} sm={2}>
            <SubtleBadge
              pill
              bg={classNames({
                success: corCircle === 'Verde',
                primary: corCircle === 'Vermelho',
                yellow: corCircle === 'Amarelo',
                info: corCircle === 'Análise Fiscal'
              })}
              className="d-flex justify-content-center align-items-center"
            >
              <p className="mb-0">{corCircle}</p>
            </SubtleBadge>
          </Col>
          <Col xs={4} sm={2}>
            <h6
              className="text-600 mb-1 text-center"
              style={{ fontSize: '0.625em' }}
            >
              {desembaraco}
            </h6>
          </Col>
          <Col
            xs={2}
            sm={1}
            className="d-flex justify-content-center align-items-center"
          >
            <Link
              to={{
                pathname: '/app/process/process-details/' + sigla + '&' + id
              }}
            >
              <FontAwesomeIcon
                icon={faFileInvoice}
                title="Detalhes"
                style={{ cursor: 'pointer' }}
                size="lg"
              />
            </Link>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const ControleCanal = ({ data, title }) => {
  return (
    <Card className="h-100 recent-activity-card">
      <FalconCardHeader title={title} titleTag="h6" />
      <SimpleBarReact style={{ height: '26rem' }}>
        <Card.Body className="ps-2 recent-activity-body-height">
          {Array.isArray(data) && data.length > 0 ? (
            <Row className="g-3 pb-s1">
              <Col>
                <Row className={classNames('g-3 mb-3 border-bottom pb-s1')}>
                  <Col xs={2} sm={1}>
                    <h6
                      className="text-800 mb-1 text-center"
                      style={{ fontSize: '0.625em' }}
                    >
                      Modal
                    </h6>
                  </Col>
                  <Col xs={4} sm={2}>
                    <h6
                      className="text-800 mb-1 text-center"
                      style={{ fontSize: '0.625em' }}
                    >
                      Processo
                    </h6>
                  </Col>
                  <Col xs={4} sm={2}>
                    <h6
                      className="text-800 mb-1 text-center"
                      style={{ fontSize: '0.625em' }}
                    >
                      Referencia
                    </h6>
                  </Col>
                  <Col xs={4} sm={2}>
                    <h6
                      className="text-600 mb-1 text-center"
                      style={{ fontSize: '0.625em' }}
                    >
                      Registro DI
                    </h6>
                  </Col>
                  <Col xs={4} sm={2}>
                    <h6
                      className="text-600 mb-1 text-center"
                      style={{ fontSize: '0.625em' }}
                    >
                      Canal
                    </h6>
                  </Col>
                  <Col xs={4} sm={2}>
                    <h6
                      className="text-600 mb-1 text-center"
                      style={{ fontSize: '0.625em' }}
                    >
                      Data Desembaraço
                    </h6>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <div className="text-center p-3">Sem processos em desembaraço</div>
          )}
          {data.map((previsao, index) => (
            <Previsao
              key={previsao.processo}
              id={previsao.id}
              previsao={previsao}
              registro={previsao.registro}
              isLast={index === data.length - 1}
              referencia={previsao.referencia}
              desembaraco={previsao.desembaraco}
              cor={previsao.cor}
            />
          ))}
        </Card.Body>
      </SimpleBarReact>
    </Card>
  );
};

Previsao.propTypes = {
  previsao: PropTypes.shape({
    id: PropTypes.number,
    processo: PropTypes.string.isRequired,
    registro: PropTypes.string.isRequired,
    modalidade: PropTypes.string.isRequired,
    destino: PropTypes.string.isRequired,
    operacao: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    referencia: PropTypes.string.isRequired,
    cor: PropTypes.string.isRequired
  }),
  isLast: PropTypes.bool
};

ControleCanal.propTypes = {
  data: PropTypes.arrayOf(Previsao.propTypes.previsao)
};

export default ControleCanal;
